export default __webpack_public_path__ + "locales/nl/DeleteThirdPartyDialog.json?hash=deb758e01aa178104a42b601e73f0fd4";